import _ from 'lodash';
export const searchAndFilterOffers = ({ sortField, sortAsc, items, searchTerm, delegatedCompanies }) => {
    function filter(_allItems, _searchTerm) {
        if (!_searchTerm) {
            return _allItems;
        }
        return _.filter(_allItems, (item) => {
            var _a;
            return (item.data.name &&
                item.data.name.toLowerCase().includes(_searchTerm.toLowerCase())) ||
                ((_a = item.data.tags) === null || _a === void 0 ? void 0 : _a.includes(_searchTerm));
        });
    }
    function filterByCompanies(_allItems, _companies) {
        if (!_companies) {
            return _allItems;
        }
        return _.filter(_allItems, (item) => {
            return _companies.includes(item.data.company);
        });
    }
    function sort(_sortField, _sortAsc, _items) {
        return _.orderBy(_items, _sortField, _sortAsc ? 'asc' : 'desc');
    }
    return sort(sortField, sortAsc, filter(filterByCompanies(items, delegatedCompanies), searchTerm));
};
